/**
 * router/index.ts
 *
 * Automatic routes for `./src/pages/*.vue`
 */

// Composables
import { createRouter, createWebHistory } from "vue-router";
import { routes, handleHotUpdate } from "vue-router/auto-routes";
import Session from "supertokens-web-js/recipe/session";

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes,
});

router.onError((error, to) => {
    if (
        error.message.includes("Failed to fetch dynamically imported module") ||
        error.message.includes("Importing a module script failed")
    ) {
        console.error(error);
        if (!to?.fullPath) {
            window.location.reload();
        } else {
            window.location = to.fullPath;
        }
    }
});

router.beforeEach(async (to, from) => {
    const { authStore, logout } = useAuth();
    const { isConnected, isAdmin, isInitialized } = storeToRefs(authStore);

    // Skip all authentication checks if going to maintenance page
    if (to.name === 'Maintenance') {
        if (!isInitialized.value) {
            authStore.checkAuth();  // Fire and forget - don't block navigation
        }
        return;
    }

    // Only await checkAuth on first load, skip on subsequent navigations
    if (!isInitialized.value) {
        await Session.attemptRefreshingSession();
        await authStore.checkAuth();
    }

    // Par défaut, les pages sont protégées
    if (!to.meta.requiresOffline && to.meta.requiresAuth !== false && !isConnected.value) {
        // Auth only page
        return { name: "Login", query: { redirect: to.name } };
    } else if (to.meta.requiresOffline && isConnected.value) {
        // Offline only page
        return { name: "Dashboard" };
    }

    if (to.meta.requiresAdmin && !isAdmin.value) {
        // Admin only page
        logout();
        return { name: "Login" };
    }

});

router.afterEach(to => {
    useHead({
        title: to?.meta?.title ? `${to.meta.title} - Nebulone` : "Nebulone",
    });

    // Set page attribute on body tag
    if (to.name) {
        document.body.setAttribute('page', to.name);
    }
});

if (import.meta.hot) {
    handleHotUpdate(router);
}

export default router;
